import get from 'lodash/get';
import {useState} from 'react';

import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import CustomInput from '../common/CustomInput';
import CustomTextField from '../common/CustomTextField';
import {useCreateReviewMutation} from '../../redux/services/reviewApi';
import useError from '../../hooks/useError';

const handleSubmit = ({createReview, setIsOpen, setError}) => (
  async formValues => {
    const result = await createReview(formValues);
    const message = get(result, 'error.data.errors[0]', null);
    if (result.error) return setError(new Error(message));
    return setIsOpen(false);
  }
);

const CreateReviewForm = props => {
  const {providerId} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(null);
  const [createReview] = useCreateReviewMutation();
  const errors = useError();
  return (
    <>
      <Button
        variant='contained'
        onClick={() => setIsOpen(true)}
      >
        Leave me a review
        <ChevronRightIcon/>
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth='sm'
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <DialogTitle variant='h2'>
          Thank You for Leaving a Review!
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={2}>
            <CustomInput required label='Rating'>
              <Rating
                required
                name='rating'
                size='small'
                style={{color: config().colors.primary}}
                onChange={(e, val) => setRating(val)}
              />
            </CustomInput>
            <CustomTextField
              required
              label='Review'
              placeholder='How did you first hear about your provider? What were your goals? Why was your experience special?'
              type='textarea'
              multiline
              rows={5}
              onChange={e => setFeedback(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={() =>
              handleSubmit({
                createReview,
                setIsOpen,
                setError: errors.create,
              })({provider_id: providerId, rating, feedback})
            }
          >
            Submit Review
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateReviewForm;
